/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import BannerList from './BannerList';
import FacadeManagerHero from './FacadeManagerHero';
import { slug } from '../../common';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.facade_manager`;

export default class FacadeManagerPage extends Page {
	oninit(vnode) {
		super.oninit(vnode);

		// If user not allowed to manage facades, redirect to home
		if (!app.session?.user?.canManageBanners()) {
			m.route.set(app.route('home'));
		}

		app.history.push('facade-manager');
		this.bodyClass = 'App--facade-manager';
		app.setTitle(t(`${prfx}.title`));

		this.refresh();
	}

	view() {
		if (this.loading) {
			return <LoadingIndicator />;
		}

		return (
			<div className="FacadeManagerPage">
				<FacadeManagerHero />
				<div className="container">
					<div className="FacadeManagerPage-content">
						<BannerList />
					</div>
				</div>
			</div>
		);
	}

	refresh() {
		this.loading = true;
		m.redraw();

		app.store.find('banners').then((banners) => {
			this.banners = banners;
			this.loading = false;
			m.redraw();
		});
	}
}
